module.exports = __webpack_public_path__ + "static/macos-93166dcd7e3d19779578b600e1c16395.png";